import axios from "axios";
import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const apiUrl = import.meta.env.VITE_API_URL + "products";

export const dynamic = "force-dynamic";

export class ProductService {
  constructor() {
    this.axiosInstance = createAuthenticatedAxiosInstance();
  }

  // add a new product
  async addProduct(product) {
    try {
      const response = await this.axiosInstance.post(apiUrl, product);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // get all products with optional params
  async getProducts(params = {}) {
    try {
      const response = await this.axiosInstance.get(apiUrl, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // get a single product
  async getProduct(id) {
    try {
      const response = await this.axiosInstance.get(`${apiUrl}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // update a product
  async updateProduct(product) {
    try {
      const response = await this.axiosInstance.put(
        `${apiUrl}/${product.id}`,
        product
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // search products
  async searchProducts(searchTerm) {
    try {
      const response = await this.axiosInstance.get(`${apiUrl}/search`, {
        params: { q: searchTerm }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // delete a product
  async deleteProduct(id) {
    try {
      const response = await this.axiosInstance.delete(`${apiUrl}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // get product history
  async getProductHistory(id) {
    try {
      const response = await this.axiosInstance.get(`${apiUrl}/${id}/history`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // return product
  async returnProduct(id, { quantity, reason }) {
    try {
      const response = await this.axiosInstance.post(`${apiUrl}/${id}/return`, {
        quantity,
        reason,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
